export const TOGGLE_TORCH_NOT_AVAILABLE_SCREEN = 'TOGGLE_TORCH_NOT_AVAILABLE_SCREEN'

export function displayTorchNotAvailableScreenReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_TORCH_NOT_AVAILABLE_SCREEN:
            return action.payload
        default: return state
    }
}